import { cn } from "@/lib/utils";
import { forwardRef } from "react";

type CarouselShellProps = {
  children: React.ReactNode;
  showLeftFade?: boolean;
  showRightFade: boolean;
  className?: string;
};

const CarouselShell = forwardRef<HTMLDivElement, CarouselShellProps>(
  ({ children, showLeftFade = false, showRightFade, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "marketplace-carousel",
          {
            "marketplace-carousel--fade-left": showLeftFade,
            "marketplace-carousel--fade-right": showRightFade,
          },
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

CarouselShell.displayName = "CarouselShell";

export default CarouselShell;
